import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import QualEventsComponent from './js/qual-events.component';

ComponentsFactory.getInstance().define('qual-events', QualEventsComponent);
